export default __webpack_public_path__ + "static/media/opensans-semibold-webfont.24289a5b.woff2";